import Card from "./card.vue";
import { install } from "@kurundata-ui-questionnaire/utils/install";

const KrCard = install(Card); // 生成带有 install 方法的组件

export default KrCard;
